import React, { FC } from 'react';
import { useFeatureFlagsContext } from 'components/FeatureFlags/FeatureFlags';
import { TextV2 } from 'components/TextV2/TextV2';
import styles from './MsrpPricing.module.scss';
import { useTranslation } from 'react-i18next';
import { PRICING } from 'components/Pricing/utils/pricingHookTranslationStrings';
import { BooleanFilter } from 'utils/TypeUtils';

interface IMsrpPricingProps {
  msrpPrice: number;
}

export const MsrpPricing: FC<IMsrpPricingProps> = ({ msrpPrice }) => {
  const { t } = useTranslation();
  const { isFlagEnabled } = useFeatureFlagsContext();
  const isMsrpEnabled = isFlagEnabled('show-msrp-global');
  const hasMsrpPrice = BooleanFilter(msrpPrice);

  if (!isMsrpEnabled || !hasMsrpPrice) return null;

  return (
    <TextV2
      variant="body-small"
      value={t(PRICING.STRING_MSRP, { price: msrpPrice })}
      className={styles.msrpPrice}
    />
  );
};
